/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { base } from '@/base/base'
import { MsgIDs } from '@/defines/MsgIDs'
import { wsClient } from '@/net/WebSocketClient'

export class JackpotGamsModule extends ModuleBase {
  public info: any = null
  public clickIng = false

  public IGem = 0 //  0:活动未激活,1:活动激活
  public isCanShow = true //是否可以展示

  public NowTime = 0 // 服务器当前时间
  public BegTime = 0 //活动开始时间
  public EndTime = 0 //活动结束时间
  public GemNum1 = 0 //绿宝石个数
  public GemGold1 = 0 //绿宝石中奖金额
  public GemNum2 = 0 //蓝宝石个数
  public GemGold2 = 0 //蓝宝石中奖金额
  public GemNum3 = 0 //红宝石个数
  public GemGold3 = 0 //红宝石中奖金额
  public GemTake = '' //图案
  public SpinsLeft = 0 //次数

  public GemSign = 0 //抽奖的宝石是什么颜色
  public GemGold = 0 //最后中奖金额

  public daojishi = 0 //真的倒计时（不需要重复请求数据）
  private _countdownTimer: any = null

  init(): void {}

  onClear(): void {
    if (this._countdownTimer) {
      clearInterval(this._countdownTimer)
      this._countdownTimer = null
    }
    //this.info = null
  }

  onLoad(): void {}

  onDestroy(): void {}

  inits2c(): void {
    ;(hall.s2c as any)['onClientGemActAck'] = (msg: any) => {
      // 检测宝石活动激活返回
      //if (msg.ret == 0) {
      // uint32 UserID = 1;	// 玩家ID
      // uint32 IGem = 2; //  0:活动未激活,2:活动激活
      //}
      if (hall.jackpotGamsModule.IGem == 0 && msg.IGem == 1) {
        //第一次接受
        //hall.popupViewModule.addPopupView(PopupViews.JackpotgamsPanel);
        hall.jackpotGamsModule.sendJackpotGemsConfig()
      }
      hall.jackpotGamsModule.IGem = msg.IGem
      hall.jackpotGamsModule.getJackGemShow()
    }

    ;(hall.s2c as any)['onClientGemDataAck'] = (msg: any) => {
      // 请求宝石活动数据返回
      //         uint32 ret = 1;
      // uint32 UserID = 2;	// 玩家ID
      // uint64 NowTime = 3; // 服务器当前时间
      // uint64 BegTime = 4; // 活动开始时间
      // uint64 EndTime = 5; // 活动结束时间

      // uint32 GemNum1 = 6; // 绿宝石个数
      // uint32 GemGold1 = 7; // 绿宝石中奖金额

      // uint32 GemNum2 = 8; // 蓝宝石个数
      // uint32 GemGold2 = 9; // 蓝宝石中奖金额

      // uint32 GemNum3 = 10; // 红宝石个数
      // uint32 GemGold3 = 11; // 红宝石中奖金额

      // string GemTake = 12;// 图案(前端透传过来保存)

      // uint32 SpinsLeft = 13;
      if (msg.ret == 0) {
        hall.jackpotGamsModule.info = msg
        hall.jackpotGamsModule.NowTime = msg.NowTime
        hall.jackpotGamsModule.BegTime = msg.BegTime
        hall.jackpotGamsModule.EndTime = msg.EndTime
        hall.jackpotGamsModule.GemNum1 = msg.GemNum1
        hall.jackpotGamsModule.GemGold1 = msg.GemGold1
        hall.jackpotGamsModule.GemNum2 = msg.GemNum2
        hall.jackpotGamsModule.GemGold2 = msg.GemGold2
        hall.jackpotGamsModule.GemNum3 = msg.GemNum3
        hall.jackpotGamsModule.GemGold3 = msg.GemGold3
        hall.jackpotGamsModule.GemTake = msg.GemTake
        hall.jackpotGamsModule.SpinsLeft = msg.SpinsLeft
        hall.jackpotGamsModule.timeChange()
        hall.eventDispatcher.emit(hall.EventDefine.OnJackPotGemsInfo)
        hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新宝石红点
      }
    }

    ;(hall.s2c as any)['onClientGemGetAck'] = (msg: any) => {
      // 请求宝石收集返回
      if (msg.ret == 0) {
        //  uint32 ret = 1;
        //     uint32 UserID = 2;	// 玩家ID
        // 	uint32 GemSign = 3; // 宝石(1:绿,2:蓝,3:红)
        hall.jackpotGamsModule.GemSign = msg.GemSign
        if (msg.GemSign == 1) {
          hall.jackpotGamsModule.GemNum1 += 1
        } else if (msg.GemSign == 2) {
          hall.jackpotGamsModule.GemNum2 += 1
        } else if (msg.GemSign == 3) {
          hall.jackpotGamsModule.GemNum3 += 1
        }
        hall.jackpotGamsModule.SpinsLeft -= 1
        hall.eventDispatcher.emit(hall.EventDefine.OnJackPotGemsGet)
        hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新宝石红点
      }
    }

    ;(hall.s2c as any)['onClientGemPrizeAck'] = (msg: any) => {
      // 请求宝石中奖奖励返回
      if (msg.ret == 0) {
        //                 uint32 ret = 1;
        //    uint32 UserID = 2;	// 玩家ID
        //    uint32 GemGold = 3; // 宝石中奖金额
        hall.jackpotGamsModule.GemGold = msg.GemGold
        hall.eventDispatcher.emit(hall.EventDefine.OnJackPotGemsGold)
        hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新宝石红点
      } else {
        base.toast(hall.Language.AddCashModule_failFun_tip)
      }
    }
  }

  onPreloadData(): void {
    this.sendJackpotGemsConfig()
  }

  //检测宝石活动激活
  gemActSend() {
    const message = {
      UserID: hall.userModule.userId,
    }
    wsClient.send(MsgIDs.ClientGemActReq, message)
  }

  //后端下发激活了，判断是否在大厅，
  // 1.（第一次直接展示），后面只有玩了子游戏，再接受后在大厅才展示
  //2.前端先不请求
  getJackGemShow() {
    if (hall.jackpotGamsModule.IGem == 1 && this.isCanShow) {
      const HallPanel = base.uiHudSystem.getFromActiveHud('HallPanel', true)
      if (HallPanel != null) {
        base.uiHudSystem.show('JackpotgamsPanel')
      }
    }
  }

  //请求宝石活动数据
  sendJackpotGemsConfig() {
    const message = {
      UserID: hall.userModule.userId,
    }
    wsClient.send(MsgIDs.ClientGemDataReq, message)
  }

  //请求宝石收集
  sendJackpotGemsGet(index: number) {
    const message = {
      UserID: hall.userModule.userId,
      GemIndx: index, // xy轴,下标0~8
    }
    wsClient.send(MsgIDs.ClientGemGetReq, message)
  }

  //请求宝石中奖奖励
  sendClientGemPrizeReq(GemSign: number) {
    const message = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
      GemSign: GemSign,
    }
    wsClient.send(MsgIDs.ClientGemPrizeReq, message)
  }

  //是否侧边栏展示这个活动
  isShowJackPotBind() {
    if (this.info) {
      return true
    }
    return false
  }

  //是否侧边栏展示这个活动
  isShowJackPotRed() {
    if (this.info && this.SpinsLeft > 0) {
      return true
    }
    return false
  }

  //领取奖励了消失活动
  endGemActivity() {
    this.info = null
    this.isCanShow = false
    hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新宝石红点
  }

  getNowTime(data: string) {
    const dateStr = data || "0-0-0 0:0:0"
    const [datePart, timePart] = dateStr.split(' ')
    const [year, month, day] = (datePart || "0-0-0").split('-').map(Number)
    const [hour, minute, second] = (timePart || "0:0:0").split(':').map(Number)
    const timestamp = new Date(year || 0, (month || 1) - 1, day || 0, hour || 0, minute || 0, second || 0).getTime()
    return timestamp
  }

  timeChange() {
    // 清除旧的倒计时，避免重复
    if (this._countdownTimer) {
      clearInterval(this._countdownTimer)
      this._countdownTimer = null
    }

    hall.jackpotGamsModule.daojishi = this.EndTime - this.NowTime

    this._countdownTimer = setInterval(() => {
      hall.jackpotGamsModule.daojishi -= 1
      if (hall.jackpotGamsModule.daojishi <= 0) {
        hall.jackpotGamsModule.daojishi = 0
        clearInterval(this._countdownTimer)
        this._countdownTimer = null
        hall.jackpotGamsModule.info = null
        hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed)
      }
    }, 1000)
  }
}
